
import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { UserTable } from './UserTable';

interface UserManagementDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const UserManagementDialog = ({
  open,
  onOpenChange,
}: UserManagementDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[900px] max-h-[80vh] p-0" dir="rtl">
        <DialogTitle className="sr-only">ניהול משתמשים</DialogTitle>
        <ScrollArea className="h-full max-h-[80vh]">
          <div className="p-6">
            <UserTable />
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
